import api from './apiClient'

export default {
  /**
   * 📋 Get invoices list (with filters & pagination)
   */
  async getInvoices(params = {}) {
    const res = await api.get('invoices', {
      params
    })
    return res.data
  },

  /**
   * 👤 Get single invoice
   */
  async getInvoice(id) {
    const res = await api.get(`invoices/${id}`)
    return res.data
  },

}